/* import __COLOCATED_TEMPLATE__ from './visualize-vocabularies-graph.hbs.js'; */
import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { all, map } from 'rsvp';
import { htmlSafe } from '@ember/template';
import { dropTask, restartableTask, timeout } from 'ember-concurrency';
import { service } from '@ember/service';
import { cached, tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { TrackedAsyncData } from 'ember-async-data';
import PapaParse from 'papaparse';
import createDownloadFile from 'ilios-common/utils/create-download-file';
import { findById, mapBy, sortBy, uniqueById } from 'ilios-common/utils/array-helpers';
let CourseVisualizeVocabulariesGraph = (_class = class CourseVisualizeVocabulariesGraph extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "router", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "tooltipContent", _descriptor3, this);
    _initializerDefineProperty(this, "tooltipTitle", _descriptor4, this);
    _initializerDefineProperty(this, "sortBy", _descriptor5, this);
    _defineProperty(this, "barHover", _buildTask(() => ({
      context: this,
      generator: function* (obj) {
        yield timeout(100);
        if (this.args.isIcon || !obj || obj.empty) {
          this.tooltipTitle = null;
          this.tooltipContent = null;
          return;
        }
        const {
          data,
          meta
        } = obj;
        this.tooltipTitle = htmlSafe(`${meta.vocabulary.title} &bull; ${data} ${this.intl.t('general.minutes')}`);
        this.tooltipContent = htmlSafe(mapBy(meta.sessions, 'title').sort().join(', '));
      }
    }), null, "barHover", "restartable"));
    _defineProperty(this, "downloadData", _buildTask(() => ({
      context: this,
      generator: function* () {
        const data = yield this.getDataObjects(this.args.course);
        const output = data.map(obj => {
          const rhett = {};
          rhett[`${this.intl.t('general.vocabulary')}`] = obj.meta.vocabulary.title;
          rhett[this.intl.t('general.sessions')] = mapBy(obj.meta.sessions, 'title').sort().join(', ');
          rhett[this.intl.t('general.minutes')] = obj.data;
          return rhett;
        });
        const csv = PapaParse.unparse(output);
        createDownloadFile(`ilios-course-${this.args.course.id}-vocabularies.csv`, csv, 'text/csv');
      }
    }), null, "downloadData", "drop"));
  }
  get outputData() {
    return new TrackedAsyncData(this.getDataObjects(this.args.course));
  }
  get data() {
    return this.outputData.isResolved ? this.outputData.value : [];
  }
  get hasData() {
    return this.data.length;
  }
  get chartData() {
    return this.data.filter(obj => obj.data);
  }
  get hasChartData() {
    return this.chartData.length;
  }
  get tableData() {
    return this.data.map(obj => {
      const rhett = {};
      rhett.minutes = obj.data;
      rhett.sessions = sortBy(obj.meta.sessions, 'title');
      rhett.vocabulary = obj.meta.vocabulary;
      rhett.vocabularyTitle = obj.meta.vocabulary.title;
      rhett.sessionTitles = mapBy(rhett.sessions, 'title').join(', ');
      return rhett;
    });
  }
  get isLoaded() {
    return this.outputData.isResolved;
  }
  get sortedAscending() {
    return this.sortBy.search(/desc/) === -1;
  }
  setSortBy(prop) {
    if (this.sortBy === prop) {
      prop += ':desc';
    }
    this.sortBy = prop;
  }
  async getDataObjects(course) {
    const sessions = await course.sessions;
    if (!sessions.length) {
      return [];
    }
    const sessionsWithMinutes = await map(sessions, async session => {
      const hours = await session.getTotalSumDuration();
      return {
        session,
        minutes: Math.round(hours * 60)
      };
    });
    const sessionWithMinutesAndVocabs = await map(sessionsWithMinutes, async ({
      session,
      minutes
    }) => {
      const terms = await session.terms;
      const vocabularies = await all(mapBy(terms, 'vocabulary'));
      return {
        session,
        vocabularies: uniqueById(vocabularies),
        minutes
      };
    });
    return sessionWithMinutesAndVocabs.reduce((set, {
      session,
      vocabularies,
      minutes
    }) => {
      vocabularies.forEach(vocabulary => {
        const id = vocabulary.id;
        let existing = findById(set, id);
        if (!existing) {
          existing = {
            id,
            data: 0,
            label: vocabulary.title,
            meta: {
              vocabulary,
              sessions: []
            }
          };
          set.push(existing);
        }
        existing.data += minutes;
        existing.meta.sessions.push(session);
      });
      return set;
    }, []).map(obj => {
      obj.description = `${obj.meta.vocabulary.title} - ${obj.data} ${this.intl.t('general.minutes')}`;
      delete obj.id;
      return obj;
    }).sort((first, second) => {
      return first.data - second.data;
    });
  }
  barClick(obj) {
    if (this.args.isIcon || !obj || obj.empty || !obj.meta) {
      return;
    }
    this.router.transitionTo('course-visualize-vocabulary', this.args.course.id, obj.meta.vocabulary.id);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "tooltipContent", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "tooltipTitle", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "sortBy", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'minutes';
  }
}), _applyDecoratedDescriptor(_class.prototype, "outputData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "outputData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSortBy", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setSortBy"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "barClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "barClick"), _class.prototype), _class);
export { CourseVisualizeVocabulariesGraph as default };